import { fork } from 'redux-saga/effects';

import { saga as analyticsSaga } from './analytics';
import { saga as fontsSaga } from './fonts';
import { saga as checkLimitsSaga } from './read.limits';
import { saga as scrollRestoreSaga } from './scroll.restore';

export function* saga() {
    yield fork(fontsSaga);
    yield fork(analyticsSaga);
    yield fork(checkLimitsSaga);
    yield fork(scrollRestoreSaga);
}
